/** @format */

import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const isPostpaidAccount = (accountType) =>
  String(accountType || "").trim().toLowerCase() === "postpaid";

export const dashboard = createAsyncThunk(
  "dashboard/fetch",
  async (params = {}, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const accountType =
        params?.accountType || state?.profile?.profileData?.account_type;

      if (isPostpaidAccount(accountType)) {
        return { status: false, credits: {}, skipped: true };
      }

      const response = await axiosInstance.post(`/EsignServices/DigitalCreditCount`);
      if (response.status && response.data) {
        return response.data;
      } else {
        throw new Error("Unexpected response format or empty data");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dashboard.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(dashboard.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(dashboard.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default dashboardSlice.reducer;
